// extracted by mini-css-extract-plugin
export default {"container":"SmallStars_container__hUsuu","singleContainer":"SmallStars_singleContainer__IRK2i","starCount":"SmallStars_starCount__R4DIv"};